import { Injectable } from '@jkhy/frontend-utils/di';
import { TermsAndConditionsClient, TermsAndConditionsModelDto } from '@treasury/api/bo';
import { TermsAndConditions } from './entities/terms-and-conditions.entity';

@Injectable()
export class TermsAndConditionsBoService {
    constructor(private readonly client: TermsAndConditionsClient) {}

    public async getTermsAndConditions(): Promise<TermsAndConditions> {
        const response = await this.client.termsAndConditionsGet();
        return TermsAndConditions.from(response.data);
    }

    public async saveTermsAndConditions(entity: TermsAndConditions): Promise<TermsAndConditions> {
        const response = await this.client.termsAndConditionsPost(
            entity.toDto() as TermsAndConditionsModelDto
        );
        return TermsAndConditions.from(response.data);
    }
}
